import _ from 'lodash'
import client from '../../utils/api'
import { createApiAction } from '../../utils/redux-tool'

const basePath = '/api/member/student/:memberId/discipline'
export const retrieve = createApiAction('member/discipline/get', client.search(basePath))

// export default function setSchoolEnrollmentReducers(builder) {
//   builder.addCase(retrieve.pending, (state) => {
//     state.disciplineLoading = true
//   })
//   builder.addCase(retrieve.fulfilled, (state, action) => {
//     const list = state.list || []
//     const { memberId } = action.meta.arg
//     state.disciplineLoading = false
//     const found = list.find(item => item.id === memberId)
//     const replace = _.extend({ id: memberId }, found, { discipline: action.payload })
//     if (found) state.list = list.map(item => (item.id === found.id ? replace : item))
//     else state.list = [...state.list, replace]
//   })
// }

export default function setSchoolEnrollmentReducers(builder) {
  builder.addCase(retrieve.pending, (state) => {
    state.disciplineLoading = true
    if (!state.list) state.list = []
  })
  builder.addCase(retrieve.fulfilled, (state, action) => {
    const list = state.list || []
    const { memberId } = action.meta.arg
    state.disciplineLoading = false
    const found = list.find(item => item.id === memberId)
    const replace = _.extend({ id: memberId }, found, { discipline: action.payload })
    if (found) state.list = list.map(item => (item.id === found.id ? replace : item))
    else state.list = [...list, replace]
  })
}